/* The details element provides the primary interaction without JavaScript. */
(function () {
  if (window.lnsBrandNavigationReady) return;
  window.lnsBrandNavigationReady = true;
  document.addEventListener('click', function (event) {
    document.querySelectorAll('details.lns-brand-menu--header[open]').forEach(function (menu) {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details.lns-brand-menu[open]').forEach(function (menu) {
      var focusInside = menu.contains(document.activeElement);
      if (focusInside || menu.classList.contains('lns-brand-menu--header')) {
        menu.removeAttribute('open');
        if (focusInside) menu.querySelector('summary').focus();
      }
    });
  });
}());


(function(){
 function closeMenu(nav){nav.classList.remove('lns-mobile-open');nav.querySelector('.lns-mobile-toggle').setAttribute('aria-expanded','false');}
 document.addEventListener('click',function(event){
  var toggle=event.target.closest('.lns-mobile-toggle');
  if(toggle){event.preventDefault();var nav=toggle.closest('.nav--mobile');var open=nav.classList.toggle('lns-mobile-open');toggle.setAttribute('aria-expanded',String(open));return;}
  document.querySelectorAll('.nav--mobile.lns-mobile-open').forEach(function(nav){if(!nav.contains(event.target)||event.target.closest('a[href]'))closeMenu(nav);});
 });
 document.addEventListener('keydown',function(event){if(event.key==='Escape')document.querySelectorAll('.nav--mobile.lns-mobile-open').forEach(function(nav){closeMenu(nav);nav.querySelector('.lns-mobile-toggle').focus();});});
}());
